import React, { HTMLAttributes } from 'react';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip';
import { ICON_TYPE_DROPDOWN, ICON_TYPE_ERROR } from '../Icon/constants';
import { getClassNames } from '../../utils';

import './Select.css';
import {getDataOrAriaProps} from '../../../utils';

interface ISelectButtonProps {
    ariaControlName?: string;
    className?: string;
    error?: string;
    onFocus?: () => void;
    onBlur?: () => void;
    onClick?:  React.MouseEventHandler<HTMLButtonElement> | undefined;
    onKeyPress?:  React.KeyboardEventHandler<HTMLButtonElement> | undefined;
    opened?: boolean;
    checked?: boolean;
    mini?: boolean;
    boxed?: boolean;
    errorInTooltip?: boolean;
    selectedOptions?: string[] | string | undefined;
    ariaHaspopup?: React.AriaAttributes["aria-haspopup"];
    ariaLabelledby?: React.AriaAttributes["aria-labelledby"];
    id?: string;
    onKeyDown?:  React.KeyboardEventHandler<HTMLButtonElement> | undefined;
    role?: React.AriaRole | undefined;
    isSingleSelect?: boolean;
}

function SelectButton({
    ariaControlName = '', opened = false, errorInTooltip = false, error = '', checked = false, className = '',
    mini = false, boxed = false, selectedOptions = undefined, onFocus = () => {}, onBlur = () => {}, onClick = (e) => {}, onKeyPress = () => {}, ariaHaspopup = undefined,
    ariaLabelledby = undefined, onKeyDown = (e) => {}, id = '', role = 'button', isSingleSelect = false, ...rest
} : ISelectButtonProps) {
    let selected: string;
    let count: number | undefined = undefined;

    if (selectedOptions) {
        if (typeof selectedOptions === 'string') {
            selected = selectedOptions;
        } else if (selectedOptions.length < 2) {
            [selected] = selectedOptions;
        } else {
            selected = selectedOptions.join(', ');
            count = selectedOptions.length;
        }
    } else selected = 'Select';

    const selectButtonClassName = getClassNames(
        'SelectButton',
        className,
        { SelectButton_tooltiped: errorInTooltip },
        { SelectButton_mini: mini },
        { SelectButton_boxed: boxed },
        { SelectButton_checked: checked },
    );

    const labelClassName = getClassNames(
        'selected__values',
        { selected__single: !count },
    );

    return (
        <button
            role={role}
            className={selectButtonClassName}
            type="button"
            id={id}
            aria-controls={ariaControlName}
            aria-expanded={opened}
            aria-haspopup={ariaHaspopup}
            aria-labelledby={ariaLabelledby}
            onFocus={onFocus}
            onBlur={onBlur}
            onClick={onClick}
            onKeyPress={onKeyPress}
            onKeyDown={onKeyDown}
            {...getDataOrAriaProps(rest)}
        >
            <span className={labelClassName}>{selected}</span>
            {count && <span className="selected__count">{count}</span>}

            {errorInTooltip && (
                <Tooltip title={error}>
                    <Icon type={ICON_TYPE_ERROR} className="anticon__error" />
                </Tooltip>
            )}

            <Icon type={ICON_TYPE_DROPDOWN} className="anticon__arrow" />
        </button>
    );
}

export default SelectButton;

